import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const TrainingAndEarning = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_270)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M39.84.49H8.493A7.837 7.837 0 00.656 8.326v31.347a7.837 7.837 0 007.837 7.837H39.84a7.837 7.837 0 007.837-7.837V8.326A7.837 7.837 0 0039.84.49z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M39.84.49H8.493A7.837 7.837 0 00.656 8.326v31.347a7.837 7.837 0 007.837 7.837H39.84a7.837 7.837 0 007.837-7.837V8.326A7.837 7.837 0 0039.84.49z"
            fill="#F2F7FF"
          />
          <Path
            d="M39.179 44.083l-1.418.98-2.156 1.49-4.876-.042-4.692-16.33.313-1.504-1.138-1.365L24 23.092a.386.386 0 01.264-.478l5.733-1.647 1.975-.568a.385.385 0 01.478.264l1.213 4.222-.353 1.368 1.177 1.5 4.692 16.33z"
            fill="url(#paint0_radial_4356_270)"
          />
          <Path
            d="M39.175 44.083l-1.418.98-6.822-23.575a.762.762 0 00-.943-.521l1.976-.568a.385.385 0 01.478.264l1.213 4.222-.353 1.368 1.177 1.5 4.692 16.33z"
            fill="#4E89EA"
          />
          <Path
            d="M34.486 27.753l-1.601.46-6.85 1.968-.824-2.868 6.844-1.965 1.607-.462.824 2.867z"
            fill="#fff"
          />
          <Path
            d="M40.2 49.046l-8.078 2.32-.487-1.694-.908-3.16 6.88-1.977 1.57-.451 1.289 4.484a.387.387 0 01-.265.478z"
            fill="#3E8AE9"
          />
          <Path
            d="M40.199 49.046l-8.079 2.32-.487-1.694 5.348-1.617a1.597 1.597 0 001.072-1.972l-.449-1.548 1.571-.451 1.289 4.484a.387.387 0 01-.265.478z"
            fill="#2666B7"
          />
          <Path
            d="M30.598 32.374a.56.56 0 10-1.076.31l3.014 10.492a.56.56 0 001.076-.31l-3.014-10.492zM35.62 40.49l-2.061-7.17a.56.56 0 10-1.076.308l2.06 7.172a.56.56 0 101.076-.31z"
            fill="#fff"
          />
          <Path
            d="M24.401 24.581v26.412h-7.3v-26.82h6.891c.226 0 .41.182.41.408z"
            fill="url(#paint1_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint2_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint3_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint4_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint5_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint6_radial_4356_270)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.813 29.667h5.93v15.734h-5.93V29.667z"
            fill="url(#paint7_radial_4356_270)"
          />
          <Path
            d="M24.398 24.581v26.412H22.83V24.581a.409.409 0 00-.41-.409h1.568c.226 0 .409.183.409.409z"
            fill="#DFB278"
          />
          <Path d="M24.401 46.553v5.187l-7.3-.746v-4.44h7.3z" fill="#F2CEA0" />
          <Path
            d="M20.778 34.709a.56.56 0 00-.56.56V43.2a.56.56 0 001.12 0v-7.933a.56.56 0 00-.56-.56zM17.102 28.917h7.3v2.985h-7.3v-2.985z"
            fill="#fff"
          />
          <Path d="M22.828 28.917h1.567v2.985h-1.567v-2.985z" fill="#E1E1DE" />
          <Path
            d="M17.097 21.58v4.354l-.746 1.493.746 1.492v18.382l-8.792-.746V28.919l.746-1.492-.746-1.493V21.58a.39.39 0 01.39-.39h8.01c.217 0 .392.175.392.39z"
            fill="url(#paint8_radial_4356_270)"
          />
          <Path
            d="M17.097 21.58v4.354l-.746 1.493.746 1.492v23.122H8.305v-2.463h5.734c.823 0 1.49-.668 1.49-1.49V21.58a.391.391 0 00-.39-.39h1.567c.216 0 .39.175.39.39z"
            fill="#4E89EA"
          />
          <Path
            d="M17.097 46.555v4.44l-8.792.747v-5.187h8.792z"
            fill="#74A9ED"
          />
          <Path d="M8.305 25.934h8.792v2.985H8.305v-2.985z" fill="#fff" />
          <Path d="M15.531 25.934h1.567v2.985h-1.567v-2.985z" fill="#E1E1DD" />
          <Path
            d="M11.403 31.8a.56.56 0 00-.56.56v10.917a.56.56 0 101.12 0V32.36a.56.56 0 00-.56-.56zM13.997 33.528a.56.56 0 00-.56.56v7.461a.56.56 0 001.12 0v-7.461a.56.56 0 00-.56-.56z"
            fill="#fff"
          />
          <Path
            d="M32.884 28.214l-.83-2.866 1.608-.462.824 2.867-1.602.46z"
            fill="#E1E1DE"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(118.429 12.432 22.37) scale(26.9499 20.9849)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(104.321 1.614 21.915) scale(25.9454 10.8616)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(104.321 1.611 21.913) scale(25.9454 10.8616)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 .582 23.365) scale(15.6413 8.58582)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 .582 23.365) scale(15.6413 8.58582)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 .582 23.365) scale(15.6413 8.58582)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 .582 23.365) scale(15.6413 8.58582)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint7_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 .582 23.365) scale(15.6413 8.58582)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint8_radial_4356_270"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(107.429 -.188 17.475) scale(24.7856 13.1738)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <ClipPath id="clip0_4356_270">
          <Path fill="#fff" d="M0 0H48V48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default TrainingAndEarning
